import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { ftthFeasibilityCheck } from "../api/api";

const ODBDetailsAction = {
    UPDATE_ODB_DETAILS : 'UPDATE_ODB_DETAILS',
    FTTH_FEASIBILITY_CHECK_SUCCESS : 'FTTH_FEASIBILITY_CHECK_SUCCESS',
    FTTH_FEASIBILITY_CHECK_FAILURE : 'FTTH_FEASIBILITY_CHECK_FAILURE',
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let feasibilityCheckCounter = 0;

const feasibilityCheck = (odb:any, bandwidth:any, provider:any) => {
    return function (dispatch: any) {
        ftthFeasibilityCheck(odb, bandwidth, provider).then((response: any) => {
            dispatch({ type: ODBDetailsAction.FTTH_FEASIBILITY_CHECK_SUCCESS, payload: response }); 
        })
            .catch((error) => {
                if (error?.response?.status) {
                    dispatch({ type: ODBDetailsAction.FTTH_FEASIBILITY_CHECK_SUCCESS, payload: error?.response });
                } else {
                    ++feasibilityCheckCounter
                    if (feasibilityCheckCounter < retryCount) {
                        const objData = JSON.parse(error?.config?.data);
                        dispatch(feasibilityCheck(objData?.ODBID, objData?.Bandwidth, objData?.SeekerID));
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const odbDetails = (city: any, district: any, region: any, FeasibilityID: any) => {
    return function (dispatch: any) {
        dispatch({ type: ODBDetailsAction.UPDATE_ODB_DETAILS, payload: {city: city, district: district,  region: region,  FeasibilityID: FeasibilityID} });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['ODBDetails'] });
    }
}

export { ODBDetailsAction, odbDetails, feasibilityCheck};